import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="progress"
export default class extends Controller {
  static targets = ["bar", "label"]
  static values = { percent: Number }

  connect() {
    this.render()
    this._connectDiscoverNextGateIfPresent()
  }

  percentValueChanged() {
    this.render()
  }

  render() {
    const percent = Number.isFinite(this.percentValue) ? this.percentValue : 0
    if (this.hasBarTarget) this.barTarget.style.width = `${percent}%`
    if (this.hasLabelTarget) this.labelTarget.textContent = `${percent}%`
  }

  _connectDiscoverNextGateIfPresent() {
    const nextUrl = this.element.dataset.nextUrl
    if (!nextUrl) return

    const actionsEl = this.element.querySelector("[data-actions-container]")
    const nextButton = this.element.querySelector("[data-next-button]")
    const dialogId = this.element.dataset.dialogId || "pick-feed-dialog"

    const update = () => {
      const results = document.getElementById("discovery_results")
      if (!results) return

      const hasAnyCard = results.querySelector("[data-discover-feed-card=\"true\"]") !== null
      if (actionsEl) {
        actionsEl.classList.toggle("hidden", !hasAnyCard)
        actionsEl.classList.toggle("flex", hasAnyCard)
      }

      const hasSelection = results.querySelector("[data-feed-selected=\"true\"]") !== null
      if (nextButton) {
        nextButton.dataset.enabled = hasSelection ? "true" : "false"
        nextButton.setAttribute("aria-disabled", hasSelection ? "false" : "true")
        nextButton.classList.toggle("cursor-not-allowed", !hasSelection)
        nextButton.classList.toggle("bg-green-600/70", !hasSelection)
        nextButton.classList.toggle("bg-green-600", hasSelection)
        nextButton.classList.toggle("hover:bg-yellow-300", hasSelection)
        nextButton.classList.toggle("hover:text-black", hasSelection)
      }
    }

    this._discoverNextGateUpdate = update
    this._discoverNextGateFrameLoad = () => update()
    this._discoverNextGateSubmitEnd = () => update()
    document.addEventListener("turbo:frame-load", this._discoverNextGateFrameLoad)
    document.addEventListener("turbo:submit-end", this._discoverNextGateSubmitEnd)

    if (nextButton) {
      this._discoverNextGateClick = (event) => {
        event.preventDefault()
        const enabled = nextButton.dataset.enabled == "true"
        if (enabled) {
          window.location.href = nextUrl
          return
        }

        const dialog = document.getElementById(dialogId)
        if (dialog && typeof dialog.showModal === "function") dialog.showModal()
      }
      nextButton.addEventListener("click", this._discoverNextGateClick)
    }

    update()
  }

  disconnect() {
    if (this._discoverNextGateFrameLoad) {
      document.removeEventListener("turbo:frame-load", this._discoverNextGateFrameLoad)
    }
    if (this._discoverNextGateSubmitEnd) {
      document.removeEventListener("turbo:submit-end", this._discoverNextGateSubmitEnd)
    }
    const nextButton = this.element.querySelector("[data-next-button]")
    if (nextButton && this._discoverNextGateClick) {
      nextButton.removeEventListener("click", this._discoverNextGateClick)
    }
  }
}


